import { render, staticRenderFns } from "./ToOrder.vue?vue&type=template&id=67544839&scoped=true&"
import script from "./ToOrder.vue?vue&type=script&lang=js&"
export * from "./ToOrder.vue?vue&type=script&lang=js&"
import style0 from "./ToOrder.vue?vue&type=style&index=0&id=67544839&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67544839",
  null
  
)

export default component.exports